export const FAST_ACCESS_PASSES = 'FAST_ACCESS_PASSES';
